import API from 'utils/api';
import { onError } from 'utils/handlers';
import { formatReceived } from 'utils/formatValues';

export const baseURI = '/catalogos/nombre-de-ordenamiento/';

/**
 * GET Nombres de Ordenamientos
 * @param {Object} params
 * @returns {Promise<Array<object>>}
 */
export const getNombresDeOrdenamientos = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Nombre de Ordenamiento
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getNombreDeOrdenamiento = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};
